import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

// components
import PatientDetailHabitLineChart from "../../chart/patientDetailPage/PatientDetailHabitLineChart";

// api
import { getQuestionFromAlcohol, getQuestionHabitFromAlcohol } from "../../../../services/apis/alcohol/question";


function SurveyItem({weekNum, questionData, patientData}) {

    return (
        <div className="survey_wrapper">
            <div className="survey_title">
                {weekNum}주차
            </div>
            <div className="survey_list_section">
                <div className="survey_item header">
                    <div className="survey_question">질문</div>
                    <div className="survey_answer_wrapper">답변</div>
                </div>
                <div className="survey_item">
                    <div className="survey_question">{questionData.contents[0].question.questionText.replace(/<br>/g,'\n').replace(/{{name}}/g,patientData.name).replace(/{{hbt_socre}}/g, "환자가 체크한 점수")}</div>
                    <div className="survey_answer_wrapper">
                        {questionData.contents[0].question.answers.filter(e=>e.itemCheck).map((answerObj, idx)=>(
                            <p key={idx}>
                                {questionData.contents[0].question.answers.filter(e=>e.itemCheck).length>1 && '- '}
                                {answerObj.itemName}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

function AlcoholCheck({patientData}) {
    const { pid } = useParams();
    const [questionHabitData, setQuestionHabitData] = useState([]);

    // 질문/답변 정보
    const [week1QuestionData, setWeek1QuestData] = useState({});
    const [week2QuestionData, setWeek2QuestData] = useState({});
    const [week8QuestionData, setWeek8QuestData] = useState({});

    async function getQuestionHabitFromAPI() {
        try {
            const res = await getQuestionHabitFromAlcohol({ pid });
            
            if(parseInt(res.status/200,10)===1){
                setQuestionHabitData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    async function getQuestionAnswerFromAPI(questionId, setData) {
        try {
            const res = await getQuestionFromAlcohol({questionId, pid});
            
            if(parseInt(res.status/200,10)===1){
                setData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    function printGraphMinWidth() {
        const size = questionHabitData.length;
        const minWidthNum = size * 150;
        
        return `${minWidthNum}px`;
    }

    useEffect(()=>{
        getQuestionHabitFromAPI();
        getQuestionAnswerFromAPI(109, setWeek1QuestData);
        getQuestionAnswerFromAPI(114, setWeek2QuestData);
        getQuestionAnswerFromAPI(121, setWeek8QuestData);
    },[])

    return (
        <div className="patientResult__check">
            <div className="row1">
                <div className="graph_title">음주습관변화도</div>
                <div className="graph_wrapper">
                    <div className="graph" style={{ minWidth: printGraphMinWidth() }}>
                        {questionHabitData.length>0 && <PatientDetailHabitLineChart
                            color='#2896E9'
                            habitData={questionHabitData}
                        />}
                    </div>
                </div>
            </div>
            <div className="row2">
                {Object.keys(week1QuestionData).length>0 && (
                    <SurveyItem
                        weekNum='1'
                        questionData={week1QuestionData}
                        patientData={patientData}
                    />
                )}
                {Object.keys(week2QuestionData).length>0 && (
                    <SurveyItem
                        weekNum='2'
                        questionData={week2QuestionData}
                        patientData={patientData}
                    />
                )}
                {Object.keys(week8QuestionData).length>0 && (
                    <SurveyItem
                        weekNum='8'
                        questionData={week8QuestionData}
                        patientData={patientData}
                    />
                )}
            </div>
        </div>
    );
}

export default AlcoholCheck;